import React from "react";
import {Redirect, Route} from "react-router";
import {useSelector} from "react-redux";
import {selectCanPlayBoardGames, selectIsAdmin, selectIsLoggedIn} from "../../store/authentication/selectors";


export const PrivateRoute = (props) => {
    const isLoggedIn = useSelector(selectIsLoggedIn);
    const canPlayBoardGames = useSelector(selectCanPlayBoardGames);
    const isAdmin = useSelector(selectIsAdmin);
    const {component: Component, boardGame, admin, ...rest} = props;
    return (
        <Route {...rest} render={props => {
            if(admin) {
                if (isLoggedIn && isAdmin) {
                    return <Component {...props} />
                } else if (isLoggedIn) {
                    return <Redirect to={{pathname: "/"}}/>
                } else {
                    return <Redirect to={{pathname: "/login", state: {from: props.location.pathname}}}/>
                }
            } else if (boardGame) {
                if (isLoggedIn && canPlayBoardGames) {
                    return <Component {...props} />
                } else if (isLoggedIn) {
                    return <Redirect to={{pathname: "/"}}/>
                } else {
                    return <Redirect to={{pathname: "/login", state: {from: props.location.pathname}}}/>
                }
            } else {
                return isLoggedIn
                    ? <Component {...props} />
                    : <Redirect to={{pathname: "/login", state: {from: props.location.pathname}}}/>
            }
        }}
        />
    )
};

export default PrivateRoute
